export default "__VITE_PUBLIC_ASSET__6894e531__"